export const rapidData = {
  id: 1,
  title: "RAPID",
  content:
    "RAPID is an IOT enabled real-time sensor data acquistion platform. It supports multiple networks and protocals like, Sigfox, GSM, 3GPP, LTE, LTE-M, Satcom., all streams that support massive IOT deployment.  Platform enables real-time analytics to visualize, track, trace, manage, monitor and analyze various types of assets and their sensory parameters. In addition, store and build a large database with historical data. AI/ML layer of RAPID platform enhances as well as automates the decision making based on historical data analysis.",
}
